import React, { useMemo, useCallback } from "react";
import DriverOrderChat from "../../orders-aviation/order-info/components/order-chat/DriverOrderChat";
import OrdersChatHub from "./OrdersChatHub";
import PartnerChat from "../../orders-aviation/order-info/components/order-chat/PartnerChat";
import { useWindowSize } from "../../../hooks/useWindowSize";

const ChatModal = ({
  isOpen,
  orderId,
  chatType = "driver-order",
  partnerId,
  isAirOrder = false,
  onClose,
  setRefreshCallback,
}) => {
  const { isMobile } = useWindowSize();

  const overlayStyle = useMemo(
    () => ({
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
    }),
    [],
  );

  const modalContentStyle = useMemo(
    () => ({
      width: isMobile ? "85%" : "45%",
      maxWidth: "600px",
      height: "80%",
      maxHeight: isMobile ? "min(80%, 400px)" : "600px",
      position: "relative",
      borderRadius: "16px",
      boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    }),
    [isMobile],
  );

  const handleOverlayClick = useCallback(
    (e) => {
      if (e.target === e.currentTarget) {
        onClose();
      }
    },
    [onClose],
  );

  const renderChatComponent = () => {
    switch (chatType) {
      case "partner":
        return (
          <PartnerChat
            partnerId={partnerId}
            onClose={onClose}
            setRefreshCallback={setRefreshCallback}
            isModal={true}
            isChatHub
          />
        );
      case "order":
        return (
          <OrdersChatHub
            isOpen={isOpen}
            orderId={orderId}
            onClose={onClose}
            serviceType={isAirOrder ? "aviation" : "order"}
          />
        );
      case "driver-order":
      default:
        return (
          <DriverOrderChat
            orderId={orderId}
            onClose={onClose}
            setRefreshCallback={setRefreshCallback}
            isModal={true}
          />
        );
    }
  };

  if (!isOpen || !orderId) {
    return null;
  }

  return (
    <div style={overlayStyle} onClick={handleOverlayClick}>
      <div style={modalContentStyle}>{renderChatComponent()}</div>
    </div>
  );
};

export default ChatModal;
